export default __webpack_public_path__ + "static/media/parkingslot2.559dc8f1.png";